module.exports = __webpack_public_path__ + "img/study-statistics-icon03.a5fd0472.png";